import { useState, useEffect } from "react";

/**
 * Returns `null` on server / first render, then the current Date after hydration.
 * Use this instead of `new Date()` at render time to avoid hydration mismatches.
 */
export function useNow() {
  const [now, setNow] = useState<Date | null>(null);
  useEffect(() => setNow(new Date()), []);
  return now;
}
